export const INTERNAL_SE_EXPORT_CONFIG = {
  drawerTitle: 'Export Internal SE Analytics',
  dashboardTitle: 'Internal SE Analytics Export',
  fileNamePrefix: 'internal-se-analytics',
  imageFilePrefix: 'internal-se',
  imageZipFileName: 'internal-se-analytics-images.zip',
  filterFields: [{ key: 'period', label: 'Period' }],
  sections: [
    {
      title: 'Global Usage',
      items: [
        {
          id: 'export-internal-global-narrative-volumes',
          label: 'Global Narrative Volumes & Trends',
        },
        { id: 'export-internal-top-narratives', label: 'Top Narratives Globally' },
        { id: 'export-internal-top-ses-globally', label: "Top SE's Globally" },
      ],
    },
    {
      title: 'Regional Usage',
      items: [
        {
          id: 'export-internal-narrative-trends-region',
          label: 'Narrative Volumes & Trends per Region',
        },
        {
          id: 'export-internal-regional-narratives-breakdown',
          label: 'Regional Narratives Breakdown',
        },
        {
          id: 'export-internal-regional-se-narrative-breakdown',
          label: 'Regional SE Narrative Runs Breakdown',
        },
      ],
    },
    {
      title: 'Bookings',
      items: [
        {
          id: 'export-internal-booking-volume-region',
          label: 'Booking Volume per Region',
        },
      ],
    },
    {
      title: 'Narrative / Run Type',
      items: [
        {
          id: 'export-internal-regional-ingestion-overview',
          label: 'Regional Ingestion Type Overview',
        },
      ],
    },
  ],
};
